export var DemoSessionStatus;
(function (DemoSessionStatus) {
    DemoSessionStatus["WAITING"] = "waiting";
    DemoSessionStatus["ACTIVE"] = "active";
    DemoSessionStatus["PAUSED"] = "paused";
    DemoSessionStatus["HANDOFF_REQUESTED"] = "handoff_requested";
    DemoSessionStatus["HANDED_OFF"] = "handed_off";
    DemoSessionStatus["COMPLETED"] = "completed";
    DemoSessionStatus["ABANDONED"] = "abandoned";
})(DemoSessionStatus || (DemoSessionStatus = {}));
export var DemoDeliveryMode;
(function (DemoDeliveryMode) {
    DemoDeliveryMode["WIDGET"] = "widget";
    DemoDeliveryMode["VIDEO_CALL"] = "video_call";
})(DemoDeliveryMode || (DemoDeliveryMode = {}));
//# sourceMappingURL=demo.js.map